import { type ComponentPropsWithoutRef } from "react"

import { FormFile } from "@/components/form-elements/FormFile"
import { cn } from "@/lib/utils"

export type FileUploadProps = ComponentPropsWithoutRef<"input"> & {
  name: string
  label: string
  initialFileName?: string
  status: "idle" | "pending" | "success" | "error"
}

export function FileUpload({
  name,
  label,
  initialFileName,
  status = "idle",
  className,
  ...restProps
}: FileUploadProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
    >
      <h2 className="w-full font-medium">{label}</h2>
      <FormFile
        name={name}
        initialFileName={initialFileName}
        status={status}
        {...restProps}
      />
    </div>
  )
}
